:host {
    display: none;
}
